var React = require('react');

function SuccessIcon (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"x":"0.632812","width":"18","height":"18","rx":"9","fill":"#00A676","key":0}),React.createElement("path",{"d":"M5.25781 9L8.38281 12.125L14.6328 5.875","stroke":"#FAFDFA","strokeWidth":"1.25","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

SuccessIcon.defaultProps = {"width":"19","height":"18","viewBox":"0 0 19 18","fill":"none"};

module.exports = SuccessIcon;

SuccessIcon.default = SuccessIcon;
